import { render, staticRenderFns } from "./WorkSchedulePanel.vue?vue&type=template&id=5c22e3bd&scoped=true&"
import script from "./WorkSchedulePanel.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WorkSchedulePanel.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WorkSchedulePanel.vue?vue&type=style&index=0&id=5c22e3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22e3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c22e3bd')) {
      api.createRecord('5c22e3bd', component.options)
    } else {
      api.reload('5c22e3bd', component.options)
    }
    module.hot.accept("./WorkSchedulePanel.vue?vue&type=template&id=5c22e3bd&scoped=true&", function () {
      api.rerender('5c22e3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/components/WorkSchedulePanel.vue"
export default component.exports